/*
 * anchor-scroll.js - spolocny posun na kotvu pod prilepenou hlavickou (JMBonline)
 * Pouzitie: na kontajner s odkazmi #kotva dopln atribut data-anchor-scroll
 *   (alebo priamo na odkaz). Ostatne odkazy #... na webe sa nemenia.
 * Preco: assets/theme.js posuva na vrch ciela bez hlavicky (data-offset=0), na mobile
 *   tak hlavicka a vyhladavanie zakryju ciel. Tento subor handler temy zastavi (capture
 *   + stopPropagation) a posunie ciel pod hlavicku. API: window.JMBAnchorScroll.offset()
 *   vrati spodnu hranicu prilepenych prvkov v px, CSS premenna --sticky-offset je
 *   nastavena pri nacitani a zmene velkosti okna (pre scroll-margin-top bez JS).
 * Produktove zalozky (snippets/product-tabs.liquid) maju vlastny posun a toto nepouzivaju.
 */
(function () {
  if (window.JMBAnchorScroll) return;
  var EXTRA = '.header__search-bar-wrapper'; /* na mobile pod prilepenou hlavickou, nie je jej sucastou */
  var GAP = 12, RETRIES = 4, RETRY_MS = 150;

  function stickyBottom() {
    var y = 1, x = Math.round(window.innerWidth / 2);
    for (var k = 0; k < 6; k++) {
      var el = document.elementFromPoint(x, y), best = 0;
      while (el && el !== document.body && el !== document.documentElement) {
        var p = getComputedStyle(el).position;
        if (p === 'fixed' || p === 'sticky') {
          var r = el.getBoundingClientRect();
          if (r.bottom > best && r.height < 500) best = r.bottom;
        }
        el = el.parentElement;
      }
      if (best > y) y = Math.ceil(best) + 1; else break;
    }
    var hb = y > 1 ? y - 1 : 0;
    var sw = document.querySelector(EXTRA);
    if (sw) {
      var sr = sw.getBoundingClientRect();
      if (sr.height > 0 && sr.top < 300 && sr.bottom > hb) hb = sr.bottom;
    }
    return hb;
  }

  function setVar() {
    document.documentElement.style.setProperty('--sticky-offset', Math.round(stickyBottom()) + 'px');
  }

  function go(target, n) {
    var d = target.getBoundingClientRect().top - (stickyBottom() + GAP);
    if (Math.abs(d) > 2) window.scrollBy({ top: d, behavior: 'instant' });
    if (n > 0) setTimeout(function () { go(target, n - 1); }, RETRY_MS);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-anchor-scroll] a[href^="#"], a[data-anchor-scroll][href^="#"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (!h || h.length < 2) return;
    var t = document.getElementById(h.slice(1));
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    go(t, RETRIES);
    try { history.replaceState(null, '', h); } catch (x) { /* nic */ }
  }, true);

  var timer;
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(setVar, 200); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setVar); else setVar();
  window.JMBAnchorScroll = { offset: stickyBottom, to: function (t) { go(t, RETRIES); } };
})();
